module.exports = __webpack_public_path__ + "img/SummaryBanner.669c1330.png";